import React from 'react';
import { Button, Form, Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { caseInsensitiveFilter } from 'Common/GridHelper';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { ManageTruckRoutesListEnum } from 'Common/FieldEnum';
import ReactTable from 'Common/ReactTableWrapper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';

const ManageTruckRouteList = props => {
  const {
    columns,
    clearFilters,
    truckRouteListData,
    truckRouteListDataLoading,
    printTruckRouteDetailLoading,
    deleteTruckRouteLoading,
    showDeleteConfirm,
    selectedRoute,
    handleDeleteDialog,
    setReactTableWrapperInstance
  } = props;
  const deleteQuestion = `Are you sure you would like to permanently delete route# ${selectedRoute &&
    selectedRoute[ManageTruckRoutesListEnum.Description]} ?`;
  return (
    <Form>
      <Grid>
        <Grid.Row>
          <Grid.Column floated={'right'} textAlign={'right'}>
            <Button
              content="Clear Filters"
              onClick={e => clearFilters()}
              type={'button'}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <ReactTable
            defaultPageSize={20}
            showPageSizeOptions={true}
            minRows={0}
            data={truckRouteListData}
            noDatatext={'No rows found'}
            resizable={false}
            className="-striped -highlight grid--fixed-row-height"
            defaultFilterMethod={caseInsensitiveFilter}
            columns={columns}
            loading={
              truckRouteListDataLoading ||
              printTruckRouteDetailLoading ||
              deleteTruckRouteLoading
            }
            menu={false}
            saveState={{
              tableName: TableNamesEnum.MANAGE_TRUCK_ROUTE_TABLE,
            }}
            onRef={setReactTableWrapperInstance}
          />
        </Grid.Row>
      </Grid>
      <YesNoDialog
        showDialog={showDeleteConfirm}
        title="Delete Route"
        question={deleteQuestion}
        yesCallback={() => {
          handleDeleteDialog(true);
        }}
        noCallback={() => {
          handleDeleteDialog(false);
        }}
      />
    </Form>
  );
};

ManageTruckRouteList.propTypes = {
  getMenuOptions: PropTypes.func,
  clearFilters: PropTypes.func,
  truckRouteListData: PropTypes.array.isRequired,
  truckRouteListDataLoading: PropTypes.bool,
  printTruckRouteDetailLoading: PropTypes.bool,
  deleteTruckRouteLoading: PropTypes.bool,
  showDeleteConfirm: PropTypes.bool,
  selectedRoute: PropTypes.object,
  handleDeleteDialog: PropTypes.func,
  setReactTableWrapperInstance: PropTypes.func,
};

ManageTruckRouteList.defaultProps = {
  getMenuOptions: () => {},
  clearFilters: () => {},
  truckRouteListDataLoading: false,
  printTruckRouteDetailLoading: false,
  deleteTruckRouteLoading: false,
  showDeleteConfirm: false,
  selectedRoute: null,
  handleDeleteDialog: () => {},
  setReactTableWrapperInstance: () => {}
};
export default ManageTruckRouteList;



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/components/managetruckrouteslist/ManageTruckRoutesList.js